import React from 'react'
import classNames from 'classnames'
import s from './CircledButtonWithLabel.less'
import T from '../i18n/T'
import SVGIcon from '../svg/SVGIcon'

export const LogoVariants = {
  smoothGreyBorder: 'logo-variant-smoothGreyBorder',
  sharpDarkGreyBorder: 'logo-variant-sharpDarkGreyBorder',
  sharpGreenBorder: 'logo-variant-sharpGreenBorder',
  blue: 'logo-variant-blue'
}

const CircledButtonWithLabel = ({
  logo,
  svgId,
  svgUrl,
  label,
  onClick,
  recenter,
  logoVariant = LogoVariants.smoothGreyBorder
}) => (
  <span className={classNames(s.container, logoVariant)} onClick={onClick}>
    <span className={classNames(s.logo, recenter && s.recenter)}>
      {svgId ? <SVGIcon icon={svgId} /> : svgUrl ? <SVGIcon url={svgUrl} /> : logo}
    </span>
    <span className={s.label}>
      <T id={label} />
    </span>
  </span>
)

export default CircledButtonWithLabel
